export const ADD_ON_MANAGER = "ADD_ON_MANAGER";
export const AUTH_AND_EVAL = "AUTH_AND_EVAL";
export const FETCH_CURRICULUM_PROGRAM_WITH_SNP_PERM_STATUS =
  "FETCH_CURRICULUM_PROGRAM_WITH_SNP_PERM_STATUS";
export const FETCH_SNP_SET_WITH_CYCLE_STATUS =
  "FETCH_SNP_SET_WITH_CYCLE_STATUS";
export const MANAGE_CURRICULUM_PERMISSION = "MANAGE_CURRICULUM_PERMISSION";
export const MANAGE_GRADES_PERMISSION = "MANAGE_GRADES_PERMISSION";
export const LIBRARY = "LIBRARY";
export const FETCH_LIBRARY_PORTAL_ACTIVATION_STATUS =
  "FETCH_LIBRARY_PORTAL_ACTIVATION_STATUS";
export const TODDLE_1p0 = "1.0";
export const TODDLE_2p0 = "2.0";
